import { gql } from "@apollo/client";
export const fetchLeaderboardStats = gql`
  query FetchLeaderboardStatistics($brokerId: ID!, $year: Int) {
    fetchLeaderboardStatistics(broker_id: $brokerId, year: $year) {
      badges {
        name
        count
        insurers {
          id
          insurer_id
          insurer_name
          total_points
          total_redeemable_points
          total_redeemable_cash_equivalent
        }
      }
      target {
        id
        broker_id
        target_name
        base_currency
        start_date
        end_date
        insurer_id
        target_badges {
          id
          name
          min_points
          max_points
          description
          minimum_cash_equivalent
          cash_equivalent
          gift_basket {
            gift_name
            gift_type
            gift_image
            gift_description
          }
        }
      }
    }
  }
`;
